import { FC } from 'react';
import { CatUtilityNavItem } from '@blocks-react/components/UtilityNavItem';
import { CatPrimaryNavItem } from '@blocks-react/components/PrimaryNavItem';
import { CatIconSyncronize } from '@blocks-react/components/Icons/Syncronize';
import { CatIconControlCenter } from '@blocks-react/components/Icons/ControlCenter';
import { MAIN_NAV_TRACK } from '../../../constants/analyticsConstants';

interface NavItemProps {
  'aria-controls'?: string;
  'aria-expanded'?: boolean;
  onClick?: () => void;
  href?: string;
  text?: string;
}

interface SubheaderControlCenterOrOrderHistoryProps {
  displayMobileNavLink?: boolean;
  id: string;
  isControlCenterEnabled?: boolean;
  isCurrent?: boolean;
  navItemProps: NavItemProps;
}

export const SubheaderControlCenterOrOrderHistory: FC<
  SubheaderControlCenterOrOrderHistoryProps
> = ({
  displayMobileNavLink = false,
  id,
  isControlCenterEnabled = false,
  isCurrent = false,
  navItemProps,
}) => {
  return displayMobileNavLink ? (
    <CatPrimaryNavItem
      data-testId="controlCenterOrOrderHistoryNavItemMobile"
      id={id}
      isCurrent={isCurrent}
      {...navItemProps}
      data-track-event={MAIN_NAV_TRACK.EVENT}
      data-track-attr-nltext={
        isControlCenterEnabled
          ? MAIN_NAV_TRACK.CONTROL_CENTER
          : MAIN_NAV_TRACK.ORDER_HISTORY
      }
      data-track-attr-context={MAIN_NAV_TRACK.TOP_MENU_CONTEXT}
      style={{
        borderBottom: '1px solid var(--cat-theme-color-border-strong-hover)',
      }}
    >
      {isControlCenterEnabled ? (
        <CatIconControlCenter slot="before" />
      ) : (
        <CatIconSyncronize slot="before" />
      )}
    </CatPrimaryNavItem>
  ) : (
    <CatUtilityNavItem
      data-testId="controlCenterOrOrderHistoryNavItemDesktop"
      id={id}
      isCurrent={isCurrent}
      {...navItemProps}
      data-track-event={MAIN_NAV_TRACK.EVENT}
      data-track-attr-nltext={
        isControlCenterEnabled
          ? MAIN_NAV_TRACK.CONTROL_CENTER
          : MAIN_NAV_TRACK.ORDER_HISTORY
      }
      data-track-attr-context={MAIN_NAV_TRACK.TOP_MENU_CONTEXT}
    >
      {isControlCenterEnabled ? (
        <CatIconControlCenter slot="before" />
      ) : (
        <CatIconSyncronize slot="before" />
      )}
    </CatUtilityNavItem>
  );
};
